import React from 'react';
import PropTypes from 'prop-types';

import Align from '@marvelapp/marvel-ui/align';
import Grid, { GridItem, InlineGrid } from '@marvelapp/marvel-ui/grid';
import Heading from '@marvelapp/marvel-ui/heading';
import LogoRow from '@marvelapp/marvel-ui/logo-row';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Position from '@marvelapp/marvel-ui/position';
import Spacing from '@marvelapp/marvel-ui/spacing';

import CustomerQuoteBlock from 'marketing-website/components/modules/CustomerQuoteBlock';
import Page from 'marketing-website/components/modules/Page';
import LandingPagesWrap from 'marketing-website/components/modules/LandingPagesWrap';
import requestQuotesLogos from 'marketing-website/configs/pages/enterprise/requestQuotesLogos';
import EnterpriseForm from 'marketing-website/components/modules/EnterpriseForm';
import TickedCopy from 'marketing-website/components/modules/TickedCopy';
import { formEnterpriseRequestQuoteId } from 'marketing-website/configs/hubspot';

import hugoAvatar from 'marketing-website/media/images/avatars/monzo-hugo.png';
import monzoLogo from 'marketing-website/media/images/logos/monzo-mini-logo.svg';

const meta = {
  title: 'Enterprise Platform - Request a quote from our team',
  meta: [
    {
      name: 'description',
      content:
        'Contact our Enterprise sales team to get started on our platform today.',
    },
    {
      name: 'keywords',
      content: 'enterprise design, design thinking, design thinking process',
    },
  ],
  header: false,
  footer: false,
};

const customerQuote =
  "We use Marvel a lot to show our customers what we're working on next. They can then give us feedback, make new suggestions. It's incredible";

const enterpriseFeatures = [
  {
    feature: 'All the features of our Team plans plus',
    tooltip: null,
  },
  {
    feature: 'Team workspaces',
    tooltip: null,
  },
  {
    feature: 'User Testing',
    tooltip: null,
  },
  {
    feature: 'Enhanced Security',
    tooltip: null,
  },
  {
    feature: '99.9% Uptime SLA',
    tooltip: null,
  },
  {
    feature: 'Priority Support',
    tooltip: null,
  },
];

export default function EnterpriseRequestQuote(history) {
  return (
    <Page {...meta}>
      <Position type="absolute" location="all">
        <Align type="middle">
          <div id="enterprise-form">
            <LandingPagesWrap history={history} showBackButton>
              <Spacing size="m" position="topBottom" type="padding">
                <PageWrap size="m" maxWidth={1080}>
                  <Grid columns={12} size="m" alignItems="center">
                    <GridItem columnSpan={12} columnSpanM={7}>
                      <div
                        style={{ height: 120 }}
                        className="breakPointM-display-none"
                      />
                      <MaxWidth value={500}>
                        <Heading size="mega" weight="bold">
                          Take the first step to Enterprise.
                        </Heading>
                      </MaxWidth>
                      <Spacing type="margin" size="m" position="top">
                        <MaxWidth value={500}>
                          <Spacing
                            size="s"
                            position="topBottom"
                            type="margin"
                          />
                          <Grid columns={2} size="m">
                            <GridItem>
                              {enterpriseFeatures.map(item => (
                                <Spacing
                                  key={item.feature}
                                  size="xs"
                                  position="topBottom"
                                  type="margin"
                                >
                                  <InlineGrid size="s">
                                    <TickedCopy>{item.feature}</TickedCopy>
                                  </InlineGrid>
                                </Spacing>
                              ))}
                            </GridItem>
                            <GridItem alignItems="flex-start">
                              <CustomerQuoteBlock
                                quote={customerQuote}
                                customerName="Hugo Conejo, Monzo"
                                avatar={hugoAvatar}
                                icon={monzoLogo}
                              />
                            </GridItem>
                          </Grid>
                        </MaxWidth>
                      </Spacing>
                      <Spacing type="margin" size="l" position="top">
                        <LogoRow
                          align="left"
                          spacing="l"
                          logos={requestQuotesLogos}
                        />
                      </Spacing>
                    </GridItem>
                    <GridItem columnSpan={12} columnSpanM={5}>
                      <Spacing size="m" position="top" type="margin">
                        <EnterpriseForm
                          ctaCopy={'Request a quote'}
                          hubspotId={formEnterpriseRequestQuoteId}
                        />
                      </Spacing>
                    </GridItem>
                  </Grid>
                  <div
                    style={{ height: 120 }}
                    className="breakPointM-display-none"
                  />
                </PageWrap>
              </Spacing>
            </LandingPagesWrap>
          </div>
        </Align>
      </Position>
    </Page>
  );
}

EnterpriseRequestQuote.propTypes = {
  history: PropTypes.object.isRequired,
};

EnterpriseRequestQuote.defaultProps = {};



// WEBPACK FOOTER //
// ./src/pages/enterprise/request-quote/index.js